import React from 'react';
import useReveal from '../hooks/use-reveal';

const WhatIsThis = () => {
  const head = useReveal();
  const body = useReveal();

  return (
    <section
      id="what"
      data-testid="what-is-this-section"
      style={{ padding: '100px 24px', maxWidth: '900px', margin: '0 auto' }}
    >
      <div ref={head.ref} className={`reveal ${head.visible ? 'visible' : ''}`}>
        <div className="yup-eyebrow" style={{ marginBottom: '20px' }}>
          What is this
        </div>
        <h2 className="yup-section-title" style={{ marginBottom: '24px' }}>
          Not a course.<br />
          Not therapy.<br />
          <em>Something different.</em>
        </h2>
      </div>

      <div
        ref={body.ref}
        className={`reveal ${body.visible ? 'visible' : ''}`}
        style={{
          display: 'grid',
          gridTemplateColumns: '1fr',
          gap: '40px',
          marginTop: '60px',
          alignItems: 'start',
        }}
      >
        <style>{`
          @media (min-width: 768px) {
            [data-testid="what-grid"] {
              grid-template-columns: 1fr 1fr !important;
              gap: 60px !important;
            }
          }
        `}</style>

        <div data-testid="what-grid" style={{ display: 'contents' }}>
          <div data-testid="what-text">
            <p style={{ color: 'var(--yup-muted)', marginBottom: '20px', fontSize: '16px', lineHeight: 1.8 }}>
              Most of us walk around with a version of ourselves on the outside that
              doesn't match what's happening on the inside.
            </p>
            <p style={{ color: 'var(--yup-muted)', marginBottom: '20px', fontSize: '16px', lineHeight: 1.8 }}>
              We built that gap for a reason.{' '}
              <strong style={{ color: 'var(--yup-ink)', fontWeight: 500 }}>
                Somewhere along the way, being too much got punished.
              </strong>{' '}
              So we learned to contain it. To soften it. To perform a version of ourselves that felt safer.
            </p>
            <p style={{ color: 'var(--yup-muted)', marginBottom: '20px', fontSize: '16px', lineHeight: 1.8 }}>
              Unmask Your Voice is a 30 day process. Each day, one simple idea.
              One honest question. An invitation to share something real —
              publicly or privately — at whatever level feels right.
            </p>
            <p style={{ color: 'var(--yup-muted)', marginBottom: '20px', fontSize: '16px', lineHeight: 1.8 }}>
              <strong style={{ color: 'var(--yup-ink)', fontWeight: 500 }}>
                You don't have to be broken to do this.
              </strong>{' '}
              You just have to be someone with a voice that hasn't been fully heard yet.
            </p>
          </div>

          <div>
            <div
              data-testid="what-quote"
              style={{
                borderLeft: '2px solid var(--yup-accent)',
                padding: '24px 28px',
                background: 'var(--yup-surface)',
              }}
            >
              <p
                className="font-serif"
                style={{
                  fontSize: 'clamp(18px, 2.5vw, 24px)',
                  fontWeight: 300,
                  fontStyle: 'italic',
                  lineHeight: 1.5,
                  color: 'var(--yup-ink)',
                }}
              >
                "When someone asks if we're okay, most of us just say yup. Not because we are.
                Just because it's easier. This is the process of changing that — one day at a time."
              </p>
              <cite
                style={{
                  display: 'block',
                  marginTop: '16px',
                  fontSize: '12px',
                  letterSpacing: '1px',
                  textTransform: 'uppercase',
                  color: 'var(--yup-muted)',
                  fontStyle: 'normal',
                }}
              >
                — Jason, Founder of YUP
              </cite>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default WhatIsThis;
